module.exports = __webpack_public_path__ + "site/img/27.d0aa997e.jpg";